import React from "react";
import { longFormatAssets } from "../../assets/longformat";
import { BiRightArrowAlt } from "react-icons/bi";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { PlayIcon } from "../../assets/Icons";
import YoutubeEmbed from "./YoutubeEmbed3";
import { longFormatData } from "../../data/data";
import { useWindowSize } from "react-use";

const LongFormat = ({ pageHeading }) => {
  const { width } = useWindowSize();
  return (
    <>
      <section className="relative z-10">
        {longFormatData?.map((data, i) => (
          <Link
            to={`details/${data?.videoId}`}
            className={`w-full font-montserrat relative flex justify-start items-end`}
            key={`long-format-${i}`}
          >
            <div className="h-[20%] z-[1] absolute pointer-events-none left-0 right-0 top-0 bg-gradient-to-b from-black/10 to-transparent md:from-black"></div>

            {i === 0 && (
              <div className="top-0 left-0 px-4 absolute md:px-[7.2vw] z-10 flex items-center pt-[25vw] md:pt-[10.29vw]">
                <Pageheading pageHeading={pageHeading} icon={<RiHome2Line />} />
              </div>
            )}

            {width > 768 ? (
              <>
                <img
                  src={data.background}
                  alt="Karma Calling"
                  className="w-full object-cover"
                  height={1020}
                  width={1920}
                />
                <img
                  src={PlayIcon}
                  alt="Play Icon"
                  className="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                />
              </>
            ) : (
              <>
                <img
                  src={data.backgroundMb}
                  alt="Karma Calling"
                  className="w-full object-cover"
                />
                <img
                  src={PlayIcon}
                  alt="Play Icon"
                  className="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                />
              </>
            )}

            <div className="absolute left-0 right-0 px-4 bottom-[4%] xl:bottom-[5%] 2xl:bottom-[10%]  w-full z-10 text-center md:text-left md:w-[60%] 2xl:w-[45%] pointer-events-none md:px-[7.2vw] md:pb-[6vw]">
              <p className="font-bold text-26 capitalize leading-[26px] sm:text-[32px]  sm:leading-[30px] text-green-end">
                {data?.name}
              </p>
              <div className="flex gap-4 items-center justify-center md:justify-start mt-4 sm:mt-8">
                <p className="font-semibold  text-14  leading-[14px] sm:text-24 sm:leading-[24px] text-white capitalize">
                  {data?.type}
                </p>
                <div className="size-2 rounded-full bg-white/50"></div>
                <p className="font-semibold  text-14  leading-[14px] sm:text-24 sm:leading-[24px] text-white">
                  {data?.year}
                </p>
                {data.seasons && (
                  <>
                    <div className="size-2 rounded-full bg-white/50"></div>
                    <p className="font-semibold text-14  leading-[14px] sm:text-24 sm:leading-[24px] text-white">
                      {`${data?.seasons} Season`}
                    </p>
                  </>
                )}
              </div>
              <p className="sm:mt-6 mt-4 text-16 leading-[26px] sm:leading-[22px] sm:text-18 text-white font-light">
                {data?.desc}
              </p>

              {/* Button */}
              <div className="border-[1px] mx-auto mt-4 md:mx-0 w-fit border-white py-[4.27vw] px-[4.27vw] md:py-[1.1vw] md:px-[1.7vw] lg:mt-[1.55vw] rounded-full lg:rounded-[3.40vw] relative overflow-hidden group">
                <button
                  className="flex items-center gap-x-3 text-white uppercase font-montserrat text-[3.73vw] leading-[0] md:text-[1.25vw] md:leading-[0] font-semibold opacity-100 relative z-10"
                  // onClick={handleWatchTrailer}
                >
                  Watch Trailer
                  <div className="flex items-center justify-center bg-[#4AB66C] rounded-full p-[2px] transition-colors duration-300 ease-in-out group-hover:bg-white">
                    <BiRightArrowAlt className="text-white w-[6.5vw] md:w-[2.60417vw] h-auto transition-transform duration-300 ease-in-out group-hover:text-[#22AD86] -rotate-45 group-hover:rotate-0" />
                  </div>
                </button>
                <div className="absolute inset-0 bg-custom-vertical-gradient transform translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></div>
              </div>
            </div>

            {[2, 3, 4].includes(i) ? (
              <div className="h-[50%] z-[2] pointer-events-none absolute left-0 right-0 bottom-0 bg-gradient-to-b from-transparent to-black/10 md:to-black"></div>
            ) : (
              <div className="h-[20%] z-[2] pointer-events-none absolute left-0 right-0 bottom-0 bg-gradient-to-b from-transparent to-black/10 md:to-black"></div>
            )}
            {i === longFormatData.length - 1 && (
              <div className="h-20 absolute left-0 right-0 bottom-0 translate-y-[98%]  bg-gradient-to-b from-black to-transparent md:from-black"></div>
            )}
          </Link>
        ))}
      </section>
    </>
  );
};

export default LongFormat;
